import { create } from 'zustand';

type IteroProposalNotificationStore = {
  showNotification: boolean;
  setShowNotification: (shouldShow: boolean) => void;
};

export const useIteroProposalNotificationStore =
  create<IteroProposalNotificationStore>(set => ({
    showNotification: false,
    setShowNotification: shouldShow => {
      set({ showNotification: shouldShow });
    },
  }));
